<template>		
	<b-container>	
		<b-row>
             <b-col class="text-center">
            <router-link to="/">Home</router-link> |
            <router-link to="/viewUnresolvedJobs">View Jobs</router-link> |
            <router-link to="/viewResolvetickets">View Tickets</router-link> |
            <router-link to="/createTicket">Create Tickets</router-link> 
            <br>
            <br>
            </b-col>
        </b-row>
        <b-row>
         <b-col class="text-center">
            <img src="img/logo.png" class="center-block" alt="EnergyDrive">
            </b-col>
        </b-row>
		<b-row >
             <b-col class="text-left">
			<h3>Add files to ticket</h3><hr>
        </b-col>
		</b-row>
		<b-row>
			<b-col>

					<!--<form action="upload" enctype="multipart/form-data" id="uploadImage" method="post">-->
					
					<div hidden>
					<input hidden type="text" name="ticket" id="selectTicket" class="form-control" v-model="idTicket"/><br>
					</div>
					<b>Add files to ticket #{{idTicket}}</b><br><br>

					<b>Description</b><textarea maxlength="249"  name="description" id="id_Description" rows="2" class="form-control" v-model="comment"></textarea ><br>
					
					<!--<input type="file" id="files" multiple v-on:change="handleFileUploads()" ref="file" class="btn btn-primary" style="width:100%;"><br>-->
                    <input type="file" id="files" name="files" multiple v-on:change="handleFileUploads()" ref="files" class="btn btn-primary" style="width:100%;"><br>
                    <br><br>
					<input type='submit' value="Upload"  id="submitbtn" style="width:100%;" class="btn btn-primary" @click="submitFiles()"><br><br>
					
					<!--<button id="submitbtn" class="btn btn-primary">Upload </button>-->
					<!--</form>-->
                    <button  name="Cancel" id="cancelbtn" class="btn btn-primary" style="width:100%;" @click="$router.go(-1)">Cancel</button> 
					
			</b-col>
			
		</b-row>
		
		
		
	</b-container>	
</template>	

<script type="text/javascript">
    import axios from 'axios';
   

    export default {
     name: 'addFile',
      data: () => ({
        employee : "",
        idTicket : null,
        resolveDate : null,
        selectedOption : 3,
        comment : "",
        file : "",
        files : "",
        getReasonTicket : null
        }),
      created : function () {
          this.idTicket = this.$route.params.idTicket;
          
      },
      methods : {
          resolveJob : function () {
			console.log("Upload File");
          },

          submitFiles : function()
          {
             let validObject = true;
        switch ( true )
        {
            case  ( (this.comment == null)||( this.comment == ""))  : 
                validObject = false;
                this.showAlert("Please add a comment.",2000,false);
                break;
            case  ( this.files.length < 1)  : 
                validObject = false;
                this.showAlert("Please add files to upload.",2000,false);
                break;
            default : validObject = true;
        }
        if ( validObject )
        { 

              console.log("this.files");
              console.log(this.files);
              var self = this;
              let idemployee = localStorage.getItem('idemployee');
              let employee = localStorage.getItem('employee');
              console.log("idemployee"+idemployee)
              let formData = new FormData();
              //formData.append('files', this.files);
              formData.append('idEmployee',idemployee);
              formData.append('employee',employee);
              formData.append('description',this.comment);
              formData.append('idTicket',this.idTicket);
              
              console.log("this.files.length :" +this.files.length);
              for( var i = 0; i < this.files.length; i++ ){
                  console.log("itr "+i);
                let file = this.files[i];
                //console.log('file2'); 
                //console.log(file);
                formData.append('files[]', file);
                console.log('formData entries');
                console.log(formData.entries());
                }
                 console.log(formData);

                axios.post(localStorage.getItem('ticketCopURL') +'/upload',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        "Authorization" : "Bearer "+localStorage.getItem('jwt') 
                    }
                }
                ).then(function(response){
                    if (response.data.status == "Success")
                    {
                        self.showAlert("File(s) were succesfully uploaded.",3000,true,"info");
                    }
                    else
                    {
                         self.showAlert("Error could not upload files.",3000,false,"error");

                    }

                    console.log('SUCCESS!!');
                })
                .catch(function(){
                    //console.log('FAILURE!!');
                    self.showAlert("Error could not upload files.",3000,false,"error");
                });
        }

          },
          showAlert : function (msg,delay,gotoprevPage,type)
        {
            let timerInterval;
            let mainObject = this;
            mainObject.$swal({
            //title: 'Auto close alert!',
            html: msg,
            type : type,
            timer: delay,
            onBeforeOpen: () => {
                mainObject.$swal.showLoading()
                timerInterval = setInterval(() => {
                mainObject.$swal.getContent().querySelector('strong')
                    
                }, 100)
            },
            onClose: () => {
                clearInterval(timerInterval)
            }
            }).then((result) => {
            if (
                // Read more about handling dismissals
                result.dismiss === mainObject.$swal.DismissReason.timer
            ) {
                if ( gotoprevPage )
                mainObject.$router.go(-1);
            }
            })  
        },

          handleFileUploads : function()
          {
               // this.files = this.$refs.file.files;
                //this.file = this.$refs.file.files[0];  // working
                this.files = this.$refs.files.files;
                console.log(this.files);

          }
      }
    }
</script>


